/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelSegnalazioneAccountRowDTO } from '../model/paged-model-segnalazione-account-row-dto';
// @ts-ignore
import { SegnalazioneAccountChiusuraForm } from '../model/segnalazione-account-chiusura-form';
// @ts-ignore
import { SegnalazioneAccountDTO } from '../model/segnalazione-account-dto';
// @ts-ignore
import { SegnalazioneAccountListFilter } from '../model/segnalazione-account-list-filter';
// @ts-ignore
import { SegnalazioneAccountNotaForm } from '../model/segnalazione-account-nota-form';
// @ts-ignore
import { SegnalazioneAccountPresaInCaricoForm } from '../model/segnalazione-account-presa-in-carico-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    SegnalazioniAccountGestioneServiceInterface,
    AggiungiNotaSegnalazioneAccountRequestParams,
    ChiudiSegnalazioneAccountRequestParams,
    GetSegnalazioneAccountBackofficeRequestParams,
    ListSegnalazioniAccountBackofficeRequestParams,
    PresaInCaricoSegnalazioneAccountRequestParams
} from './segnalazioni-account-gestione.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class SegnalazioniAccountGestioneService extends BaseService implements SegnalazioniAccountGestioneServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Aggiunge una nota allo storico di una segnalazione account (SUPERADMIN).
     * Non cambia lo stato e non richiede la version; ammessa in ogni stato.
     * @endpoint post /api/v1/gestione/segnalazioni-account/{id}/note
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public aggiungiNotaSegnalazioneAccount(requestParameters: AggiungiNotaSegnalazioneAccountRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SegnalazioneAccountDTO>;
    public aggiungiNotaSegnalazioneAccount(requestParameters: AggiungiNotaSegnalazioneAccountRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SegnalazioneAccountDTO>>;
    public aggiungiNotaSegnalazioneAccount(requestParameters: AggiungiNotaSegnalazioneAccountRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SegnalazioneAccountDTO>>;
    public aggiungiNotaSegnalazioneAccount(requestParameters: AggiungiNotaSegnalazioneAccountRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling aggiungiNotaSegnalazioneAccount.');
        }
        const segnalazioneAccountNotaForm = requestParameters?.segnalazioneAccountNotaForm;
        if (segnalazioneAccountNotaForm === null || segnalazioneAccountNotaForm === undefined) {
            throw new Error('Required parameter segnalazioneAccountNotaForm was null or undefined when calling aggiungiNotaSegnalazioneAccount.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/segnalazioni-account/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/note`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SegnalazioneAccountDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: segnalazioneAccountNotaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Chiude una segnalazione account con un esito (SUPERADMIN).
     * APERTA o IN_LAVORAZIONE -&gt; CHIUSA; esito obbligatorio. ACCOUNT_ABUSIVO_ANONIMIZZATO e\&#39; ammesso solo se l\&#39;account segnalato risulta gia\&#39; anonimizzato (o non esiste piu\&#39;): l\&#39;esito registra un fatto, non anonimizza.
     * @endpoint post /api/v1/gestione/segnalazioni-account/{id}/chiusura
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public chiudiSegnalazioneAccount(requestParameters: ChiudiSegnalazioneAccountRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SegnalazioneAccountDTO>;
    public chiudiSegnalazioneAccount(requestParameters: ChiudiSegnalazioneAccountRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SegnalazioneAccountDTO>>;
    public chiudiSegnalazioneAccount(requestParameters: ChiudiSegnalazioneAccountRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SegnalazioneAccountDTO>>;
    public chiudiSegnalazioneAccount(requestParameters: ChiudiSegnalazioneAccountRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling chiudiSegnalazioneAccount.');
        }
        const segnalazioneAccountChiusuraForm = requestParameters?.segnalazioneAccountChiusuraForm;
        if (segnalazioneAccountChiusuraForm === null || segnalazioneAccountChiusuraForm === undefined) {
            throw new Error('Required parameter segnalazioneAccountChiusuraForm was null or undefined when calling chiudiSegnalazioneAccount.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/segnalazioni-account/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/chiusura`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SegnalazioneAccountDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: segnalazioneAccountChiusuraForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di una segnalazione account con storico (SUPERADMIN).
     * Include recapiti e testo del segnalante, l\&#39;account contestato (anonimizzato&#x3D;true anche se l\&#39;utente non esiste piu\&#39;) e gli eventi in ordine cronologico.
     * @endpoint get /api/v1/gestione/segnalazioni-account/{id}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getSegnalazioneAccountBackoffice(requestParameters: GetSegnalazioneAccountBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SegnalazioneAccountDTO>;
    public getSegnalazioneAccountBackoffice(requestParameters: GetSegnalazioneAccountBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SegnalazioneAccountDTO>>;
    public getSegnalazioneAccountBackoffice(requestParameters: GetSegnalazioneAccountBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SegnalazioneAccountDTO>>;
    public getSegnalazioneAccountBackoffice(requestParameters: GetSegnalazioneAccountBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getSegnalazioneAccountBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/segnalazioni-account/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SegnalazioneAccountDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista paginata delle segnalazioni account (SUPERADMIN).
     * Filtri opzionali: stato, q (riferimento), da/a (data di creazione, estremi inclusi). Ordinamento predefinito createdAt desc, size 20. I recapiti e il testo del segnalante non sono nella lista, solo nel dettaglio.
     * @endpoint get /api/v1/gestione/segnalazioni-account
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listSegnalazioniAccountBackoffice(requestParameters: ListSegnalazioniAccountBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelSegnalazioneAccountRowDTO>;
    public listSegnalazioniAccountBackoffice(requestParameters: ListSegnalazioniAccountBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelSegnalazioneAccountRowDTO>>;
    public listSegnalazioniAccountBackoffice(requestParameters: ListSegnalazioniAccountBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelSegnalazioneAccountRowDTO>>;
    public listSegnalazioniAccountBackoffice(requestParameters: ListSegnalazioniAccountBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listSegnalazioniAccountBackoffice.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listSegnalazioniAccountBackoffice.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/segnalazioni-account`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelSegnalazioneAccountRowDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Prende in carico una segnalazione account (SUPERADMIN).
     * APERTA -&gt; IN_LAVORAZIONE. Richiede la version corrente.
     * @endpoint post /api/v1/gestione/segnalazioni-account/{id}/presa-in-carico
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public presaInCaricoSegnalazioneAccount(requestParameters: PresaInCaricoSegnalazioneAccountRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SegnalazioneAccountDTO>;
    public presaInCaricoSegnalazioneAccount(requestParameters: PresaInCaricoSegnalazioneAccountRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SegnalazioneAccountDTO>>;
    public presaInCaricoSegnalazioneAccount(requestParameters: PresaInCaricoSegnalazioneAccountRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SegnalazioneAccountDTO>>;
    public presaInCaricoSegnalazioneAccount(requestParameters: PresaInCaricoSegnalazioneAccountRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling presaInCaricoSegnalazioneAccount.');
        }
        const segnalazioneAccountPresaInCaricoForm = requestParameters?.segnalazioneAccountPresaInCaricoForm;
        if (segnalazioneAccountPresaInCaricoForm === null || segnalazioneAccountPresaInCaricoForm === undefined) {
            throw new Error('Required parameter segnalazioneAccountPresaInCaricoForm was null or undefined when calling presaInCaricoSegnalazioneAccount.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/segnalazioni-account/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/presa-in-carico`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SegnalazioneAccountDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: segnalazioneAccountPresaInCaricoForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
